/**
 * `deadlines.*` wire contract (Increment 10) — export-credential expiry hygiene.
 * Generic compliance (`tenantedProcedure`). Read-only.
 */
import { z } from "zod";
import { isoDate } from "../_common.js";

export const expiryWarning = z.object({
  credential: z.enum(["LUT", "RCMC"]),
  label: z.string(),
  expiryDate: isoDate,
  daysToExpiry: z.number().int(),
  status: z.enum(["expired", "expiring", "ok"]),
});

export const listInput = z.object({});
export const listOutput = z.object({ warnings: z.array(expiryWarning) });

export type ListOutput = z.infer<typeof listOutput>;
